"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _translations = require("../../libs/translationsUtils/translations");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var calloutBoxPlugin = {
  init: function init(editor) {
    var _window$CKEDITOR$conf;

    editor.ui.addRichCombo('Callout', {
      label: (0, _translations.t)('Common', 'editor.callout'),
      panel: {
        css: (_window$CKEDITOR$conf = window.CKEDITOR.config.contentsCss) === null || _window$CKEDITOR$conf === void 0 ? void 0 : _window$CKEDITOR$conf.concat((0, _globals.default)('cssLink')),
        multiSelect: false
      },
      init: function init() {
        this.add("<section aria-label=\"".concat((0, _translations.t)('Common', 'editor.callout'), " 1\" class=\"callout callout-green\"><div></div></section>"), "<span class=\"callout-trigger callout-green\">".concat((0, _translations.t)('Common', 'editor.callout'), " 1</span>"));
        this.add("<section class=\"callout callout-blue\" aria-label=\"".concat((0, _translations.t)('Common', 'editor.callout'), " 2\"><div></div></section>"), "<span class=\"callout-trigger callout-blue\">".concat((0, _translations.t)('Common', 'editor.callout'), " 2</span>"));
        this.add("<section class=\"callout callout-yellow\" aria-label=\"".concat((0, _translations.t)('Common', 'editor.callout'), " 3\"><div></div></section>"), "<span class=\"callout-trigger callout-yellow\">".concat((0, _translations.t)('Common', 'editor.callout'), " 3</span>"));
        this.add("<section class=\"callout callout-red\" aria-label=\"".concat((0, _translations.t)('Common', 'editor.callout'), " 4\"><div></div></section>"), "<span class=\"callout-trigger callout-red\">".concat((0, _translations.t)('Common', 'editor.callout'), " 4</span>"));
        this.add("<section class=\"callout callout-gray\" aria-label=\"".concat((0, _translations.t)('Common', 'editor.callout'), " 5\"><div></div></section>"), "<span class=\"callout-trigger callout-gray\">".concat((0, _translations.t)('Common', 'editor.callout'), " 5</span>"));
      },
      onClick: function onClick(evt) {
        editor.execCommand('callout', {
          template: evt
        });
      }
    });
    editor.addCommand('callout', {
      editorFocus: 1,
      exec: function exec(editor, data) {
        var range = editor.getSelection().getRanges()[0];
        var allParents = range.endContainer.getParents();
        var isCursorInCallout = false;
        var topParent = null;

        for (var idx = 0; idx < allParents.length - 1; idx++) {
          var _parent$$$classList;

          var parent = allParents[idx];

          if ((_parent$$$classList = parent.$.classList) !== null && _parent$$$classList !== void 0 && _parent$$$classList.contains('cke_widget_callout-widget')) {
            isCursorInCallout = true;
            topParent = allParents[idx - 1];
            break;
          }
        }

        if (isCursorInCallout) {
          range.moveToPosition(topParent, window.CKEDITOR.POSITION_BEFORE_END);
          editor.getSelection().selectRanges([range]);
          editor.insertHtml('<br />');
        } else {
          editor.insertHtml(data.template);
        }
      }
    });
    editor.widgets.add('callout-widget', {
      // Add allowedContent property to define what HTML elements and attributes are permitted
      allowedContent: 'section(!callout,callout-*)[aria-label,class,role]; div',
      editables: {
        content: {
          selector: 'div'
        }
      },
      init: function init() {
        var _this = this;

        this.element.$.addEventListener('keyup', function (evt) {
          var _range$getBoundaryNod;

          if (evt.key !== 'Enter') {
            return;
          }

          var range = editor.getSelection().getRanges()[0];
          var rangeStartPosition = (_range$getBoundaryNod = range.getBoundaryNodes()) === null || _range$getBoundaryNod === void 0 ? void 0 : _range$getBoundaryNod.startNode;

          if (rangeStartPosition && rangeStartPosition.$.innerHTML === '<br>') {
            var allParents = range.endContainer.getParents();
            var topParent = null;

            for (var idx = 0; idx < allParents.length - 1; idx++) {
              var _parent$$$classList2;

              var parent = allParents[idx];

              if ((_parent$$$classList2 = parent.$.classList) !== null && _parent$$$classList2 !== void 0 && _parent$$$classList2.contains('cke_widget_callout-widget')) {
                topParent = parent;
                break;
              }
            }

            rangeStartPosition.remove();
            var emptyParagraph = range.endContainer.remove();
            emptyParagraph.insertAfter(topParent);
            range.moveToPosition(emptyParagraph, window.CKEDITOR.POSITION_BEFORE_END);
            editor.getSelection().selectRanges([range]);
          }
        });
        this.once('focus', function () {
          var calloutText = _this.element.$.getElementsByTagName('div')[0];

          calloutText.focus();
        });
        this.element.setAttribute('aria-label', 'callout');
        this.element.setAttribute('role', 'note');
      },
      upcast: function upcast(elem) {
        return elem.name === 'section' && elem.classes && elem.classes.indexOf('callout') !== -1;
      }
    });
  }
};
var _default = calloutBoxPlugin;
exports.default = _default;